import { render, staticRenderFns } from "./ConfirmPlanChangeDialog.vue?vue&type=template&id=56d8b995&scoped=true"
import script from "./ConfirmPlanChangeDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmPlanChangeDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPlanChangeDialog.vue?vue&type=style&index=0&id=56d8b995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8b995",
  null
  
)

export default component.exports